module.exports = {
  CONTACT_US_REQUEST: "CONTACT_US_REQUEST",
  CONTACT_US_LIST_SUCCESS: "CONTACT_US_LIST_SUCCESS",
  CONTACT_US_LIST_FAIL: "CONTACT_US_LIST_FAIL",
};
